import { getCookie, saveCookie, removeCookie } from '@/store/cookies'
let o = {}
o.save = function (path, val) { // 保存查询记录
	let o
	if (getCookie('query_record')) {
		o = getCookie('query_record')
	} else {
		o = {}
	}
	o[path] = val
	saveCookie('query_record', o)
}
export default o



// WEBPACK FOOTER //
// ./src/utils/s_query.js